import { ONLINE_BOOKING_LINK } from 'shared/constants/links';
import type { TBanner } from 'shared/types/banner';

export const HOST_PRE_FOOTER_BANNER: TBanner = {
  title: 'Размещайтесь бесплатно и зарабатывайте на посуточной аренде',
  linkBtn: {
    url: ONLINE_BOOKING_LINK,
    text: 'Как это работает',
  },
  imageClass: 'chair',
};
